<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
			
			:navigableDetail="false"
		></pui-datatable>
		<vcontrolnotificacion-modals
			:modelName="modelName"
		></vcontrolnotificacion-modals>
	</div>
</template>

<script>
 //import vcontrolnotificacionActions from './VcontrolnotificacionActions';
// import vcontrolnotificacionModals from './VcontrolnotificacionModals.vue';

export default {
	name: 'vcontrolnotificacion-grid',
	components: {
		// 'vcontrolnotificacion-modals': vcontrolnotificacionModals
	},
	data() {
		return {
			modelName: 'vcontrolnotificacion',
			//actions: vcontrolnotificacionActions.gridactions,
			modelColumnDefs: {
				art15: {
					render: data => {
						if (data == 'S') {
							//return this.returnYes;
							return 1;
						} else {
							//return this.returnNo;
							return 0;
						}
					}
				},
				tracanlimitada: {
					render: data => {
						if (data == 'S') {
							return 1;
						} else {
							return 0;
						}
					}
				},
				envcumpleimdg: {
					render: data => {
						if (data == 'S') {
							return 1;
						} else {
							return 0;
						}
					}
				},
				matesiso: {
					render: data => {
						if (data == 'S') {
							return 1;
						} else {
							return 0;
						}
					}
				},
			},
			masterDetailColumnVisibles: {
				idtipbulto: false,
				desctipocarga: false,
			}
		}
	},

	computed: {
		returnYes() {
			return this.$t('yes');
		},

		returnNo() {
			return this.$t('no');
		}
	}
}
</script>
